var rates = {"AED":3.67303,"AFN":72.50001,"ALL":95.811148,"AMD":403.866051,"ANG":1.802911,"AOA":828.522,"ARS":844.269435,"AUD":1.533797,"AWG":1.802,"AZN":1.7,"BAM":1.802174,"BBD":2,"BDT":109.790901,"BGN":1.800355,"BHD":0.376794,"BIF":2867.5,"BMD":1,"BND":1.343383,"BOB":6.912629,"BRL":4.9435,"BSD":1,"BTC":1.5012608e-05,"BTN":82.914687,"BWP":13.740676,"BYN":3.273731,"BZD":2.016411,"CAD":1.356569,"CDF":2770,"CHF":0.884184,"CLF":0.035331,"CLP":974.88,"CNH":7.208284,"CNY":7.1988,"COP":3944.45,"CRC":514.261682,"CUC":1,"CUP":25.75,"CVE":101.9,"CZK":23.3618,"DJF":177.5,"DKK":6.862688,"DOP":58.7,"DZD":134.618977,"EGP":30.8989,"ERN":15,"ETB":56.770172,"EUR":0.920689,"FJD":2.24625,"FKP":0.787524,"GBP":0.787524,"GEL":2.65,"GGP":0.787524,"GHS":12.725,"GIP":0.787524,"GMD":67.975,"GNF":8597.5,"GTQ":7.813904,"GYD":209.553388,"HKD":7.824522,"HNL":24.705021,"HRK":6.937309,"HTG":132.624456,"HUF":364.610911,"IDR":15735.711078,"ILS":3.57775,"IMP":0.787524,"INR":82.903591,"IQD":1310.487121,"IRR":42030,"ISK":137.65,"JEP":0.787524,"JMD":155.808105,"JOD":0.709,"JPY":150.44788889,"KES":144.5,"KGS":89.43,"KHR":4069,"KMF":454.525146,"KPW":900,"KRW":1332.01016,"KWD":0.307614,"KYD":0.833637,"KZT":452.321603,"LAK":20888.094564,"LBP":89762.5,"LKR":308.216208,"LRD":191.999993,"LSL":19.074588,"LYD":4.83301,"MAD":10.084819,"MDL":17.649228,"MGA":4510,"MKD":56.779905,"MMK":2100.725256,"MNT":3450,"MOP":8.060926,"MRU":39.803916,"MUR":45.86155,"MVR":15.4,"MWK":1683.931619,"MXN":16.968321,"MYR":4.7235,"MZN":63.850001,"NAD":19.074588,"NGN":1512.49,"NIO":36.821179,"NOK":10.552986,"NPR":132.663141,"NZD":1.639418,"OMR":0.384948,"PAB":1,"PEN":3.77125,"PGK":3.81665,"PHP":56.032504,"PKR":279.44761,"PLN":3.97862,"PYG":7286.86099,"QAR":3.649867,"RON":4.5781,"RSD":107.887,"RUB":91.491308,"RWF":1278.69926,"SAR":3.750409,"SBD":8.475946,"SCR":13.627722,"SDG":601,"SEK":10.350622,"SGD":1.34292,"SHP":0.787524,"SLL":20969.5,"SOS":571.659768,"SRD":35.177,"SSP":130.26,"STD":22281.8,"STN":22.575547,"SVC":8.752862,"SYP":2512.53,"SZL":19.070348,"THB":35.747,"TJS":10.958816,"TMT":3.51,"TND":3.1165,"TOP":2.370158,"TRY":31.557892,"TTD":6.786392,"TWD":31.556502,"TZS":2550.844735,"UAH":38.31485,"UGX":3921.697887,"USD":1,"UYU":39.078732,"UZS":12529.012002,"VES":36.035053,"VND":24685.268915,"VUV":118.722,"WST":2.8,"XAF":603.93212,"XAG":0.04200975,"XAU":0.0004718,"XCD":2.70255,"XDR":0.754023,"XOF":603.93212,"XPD":0.00105168,"XPF":109.867373,"XPT":0.00110944,"YER":250.399984,"ZAR":19.017138,"ZMW":23.682804,"ZWL":322};
var transparent = true;
var $navbar = $('.navbar[color-on-scroll]');

var slider2 = document.getElementById("myRange2");
var slider3 = document.getElementById("myRange3");
var output2 = document.getElementById("slider-value2");
var output3 = document.getElementById("slider-value3");
var output6 = document.getElementById("slider-value6");

$(document).ready(function () {
  if($('.testimonies-wrapper').length) {
    var slider4 = tns({
      container: '.testimonies-wrapper',
      "items": 1,
      "axis": "vertical",
      controlsText: ['', ''],
      controls: true,
      nav: false,
      "slideBy": "page",
      "mouseDrag": false,
      touch: false,
      "swipeAngle": false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
      "speed": 400
    });
  }
  setTimeout(function() {
    WebFont.load({
      google: {
        families: ['Lato:400,700', 'Josefin Sans:400,600,700']
      }
    });
  }, 3000);

  if($('#box1').length) {
    $('#box1').show();
  }
  if(!($('.pricing').length && $('.pricing-table-row').length)) {
    setTimeout(function() {
    $('#preloader').hide();
    $('#main-content').show();
    $('body').css({'overflow':'visible'});
    }, 100);
  }

  // if($(".value_text").length) {
  //   index = 1
  //   var box_ele, box_img;
  //   setInterval(function () {
  //     // console.log(index)
  //     $(".value_box").removeClass('box').addClass('x-padding-1 y-padding-1');
  //     $(".value_image").hide();

  //     box_ele = $(".value_box")[index];
  //     $(box_ele).addClass('box').removeClass('x-padding-1 y-padding-1');

  //     box_img = $(".value_image")[index];
  //     $(box_img).show();
      
  //     index = index + 1;
  //     if(index == 3) {
  //       index = 0;
  //     }
  //   }, 3000);
  // }


  $('.navbar-burger').click(function() {
   
    $(this).toggleClass('is-active');
    $('.navbar-menu').toggleClass('is-active');
  })

  $(window).on('scroll', function () {
    if ($(document).scrollTop() > 100) {
      if (transparent) {
        transparent = false;
        $navbar.removeClass('navbar-transparent');
      }
    } else {
      if (!transparent) {
        transparent = true;
        $navbar.addClass('navbar-transparent');
      }
    }
  });

  let urlParams = new URLSearchParams(window.location.search)
  if(urlParams.has('contact_us') || urlParams.has('demo') || urlParams.has('partners')) {
    $('#planModal').addClass('is-active');
    $('html').addClass('is-clipped');
    if(urlParams.has('demo')) {
      $("#message").text("Please check your email for demo account details.")
    }
  }


  function navMenu() {
    $(".navmain li").each(function () {
      var e = $(this),
        t = e.find(".dropdown"),
        n = e.find("a").eq(0);
      t.length && (e.addClass("hasdrop"), n.length && n.addClass("hasdrop-a"))
    });
    var e, t = ($(window), $(".hasdrop-a"));
    t.siblings(".dropdown").hide(), $(".hasdrop");
     console.log('hi')
    t.click(function () {
        return e = $(this).closest(".navmain > ul > li"), e.siblings().find(".dropdown").slideUp(300), e.siblings().removeClass("drop-active"), e.find(".dropdown").slideToggle(300), e.toggleClass("drop-active"), !1
      }), $(".hasdrop.drop-active .dropdown").show(),
      $(".navbar-burger").click(function () {
        return $("body").toggleClass("navmain-active"), $(".navmain > ul > li:nth-child(1) .dropdown").slideToggle().parent().toggleClass("drop-active"), !1
      }), $(".partner-sticky-header .links a").click(function () {
        $("body").removeClass("navmain-active")
      })
  }
  navMenu();


  $(".highlight-text").each(function() {
    var highlight = $(this).data('highlight-text');
    var spn = '<span class="highlight">' + highlight + '</span>';
    var text = $(this).text();
    $(this).html(text.replace(highlight, spn));
  })


  $(".data-link").each(function() {
    var url = $(this).data('link');    
    var text = $(this).data('link-text');
    var alink = '<a class="has-text-dark" href="' + url + '"><strong>' + text + '</strong></a>';
    var full_text = $(this).text();
    $(this).html(full_text.replace(text, alink));
  })

  $('.pricing-tabs .tab').click(function() {
    $('.pricing-tabs .tab').removeClass('selected');
    $(this).addClass('selected')
    var selectedAttrib = $(this).attr('href')
    if(selectedAttrib=='#single-school'){
      $('#single-school-pricing-table').show();
      $('#multi-school-pricing-table').hide();
      $('.step .single-school-plan-slider').show();
      $('.step .multi-school-plan-slider').hide();
    }else{
      $('#single-school-pricing-table').hide();
      $('#multi-school-pricing-table').show();
      $('.step .single-school-plan-slider').hide();
      $('.step .multi-school-plan-slider').show();
    }
  })

  $('.plan-detail-feature').each(function() {
    var count = 0;
    count += $(this).find('tbody tr');
    count += $(this).find('tfoot tr');

  });

  $('.view-more-button').click(function() {
    console.log(this)
    $(this).closest(".plan-detail-feature").find('table tfoot').fadeToggle(200);
  })

  //code to show modal pricing
  $('.open-modal').on('click', function() {
    $('#planModal').addClass('is-active');
    $('html').addClass('is-clipped');
    $('.step.step1').show();
  })

  //code to close modal pricing
  $('.close-modal, .modal .modal-background').on('click', function() {
    $('#planModal').removeClass('is-active');
    $('html').removeClass('is-clipped');
    $('.step').hide();
  })
  var $tabs = $("ul.tabs li"),
    clickDisabled = false;

  $tabs.click(function(){ 
    if(clickDisabled){
      return;
    }
      if (!$(this).hasClass("active")) {
        var tabNum = $(this).index();
        var nthChild = tabNum + 1;
        $("ul.tabs li.active").removeClass("active");
        $(this).addClass("active");
        // $("ul.tab li.active").fadeOut(300, function(){
        //   $(this).removeClass("active");
        // });
        $("ul.tab li").removeClass("active");
        $("ul.tab li:nth-child("+nthChild+")").addClass("active");
      }
    
    clickDisabled = true;
    setTimeout(function(){clickDisabled = false;}, 500);

  });

  if(slider2 !== null) {
    calculatePrice();
  }
})


var multiplier = 1;
var currency = 'USD';



if(slider2 !== null && slider3 !== null) {
    console.log(rates)
    var arrOptions = [];
    for (var key in rates) {
      arrOptions.push("<option data-id='" + key +  "' value='" + rates[key] + "'>" + key + "</option>");
    }

    document.getElementById("selectInput").innerHTML = arrOptions.join('');
    $('#selectInput option[data-id="USD"]').prop('selected', true);

    document.getElementById("selectInput").oninput = function() {
      multiplier = this.value;
      currency = this.options[this.selectedIndex].dataset.id;
      $('.currency').text(currency);
      calculatePrice();
    }
    $('#preloader').hide();
    $('#main-content').show();
    $('body').css({'overflow':'visible'});
}
// let exchange = fetch()
// console.log(exchange)

var output7 = document.getElementById("final-price");


var discount_output = document.getElementById("discount");
var price_per_student_output = document.getElementById("price_per_student");


if (slider2 !== null && slider3 !== null) {
    
    // Display the default slider value
    // output6.innerHTML = parseInt(slider2.value * 0.2); // Display the default slider value
    // Update the current slider value (each time you drag the slider handle)
    slider2.oninput = function() {
        setSlider2(this.value)
    }
    slider3.oninput = function() {
        setSlider3(this.value)
    }
    output7.innerHTML = slider2.value * 3;

    function setSlider2(value) {
        // output6.innerHTML = value * 0.2;
        console.log(value)
        // output7.innerHTML = slider2.value * 3 ;
        calculatePrice()
    }

    function setSlider3(value) {
        // output6.innerHTML = value * 0.2;
        console.log(value)
        // output7.innerHTML = slider3.value * 3 ;
        calculatePrice()
    }
}

function calculatePrice() {
  
  var tution_fees_per_year = slider3.value

  var price_per_student = tution_fees_per_year * 0.01

  var total_number_of_students = slider2.value

  var total_before_discount = price_per_student * total_number_of_students

  // console.log("Number of students - ", total_number_of_students)
  // console.log("Price per student - ", price_per_student)

  // console.log("Total before discount - ", total_before_discount)

  // 0% - 40% - 100 - 4000
  // 1 - 0.03%
  // 10 - 0.3%
  // 100 - 3%
  // 1000 - 30%

  if( total_number_of_students <= 99) {
    var discount_percentage = 100
    var total_after_discount = total_before_discount - (total_before_discount * (discount_percentage * 0.01) )
    // console.log("Total after discount - ", total_before_discount )
  }

  if( total_number_of_students > 99 && total_number_of_students < 1000) {
    var discount_percentage = Math.ceil(total_number_of_students * 0.03)
    // console.log("Discount %", discount_percentage)
    total_after_discount = total_before_discount - (total_before_discount * (discount_percentage * 0.01) )
    // console.log("Total after discount - ", Math.floor(total_after_discount))
    // console.log("Price per student after discount - ", total_after_discount/total_number_of_students)

  }
  if( total_number_of_students >= 1000) {
    var discount_percentage = 30
    // console.log("Discount %", discount_percentage)
    var total_after_discount = total_before_discount - (total_before_discount * (discount_percentage * 0.01) )
  
    // console.log("Total after discount - ", Math.floor(total_after_discount) )
    // console.log("Price per student after discount - ", total_after_discount/total_number_of_students)
  }
  if(total_number_of_students > 2000) {
    output2.innerHTML = 2000 + '+';
  }
  else {
    output2.innerHTML = slider2.value;
  }
  if(tution_fees_per_year > 5000) {
    output3.innerHTML = Math.floor(5000 * multiplier) + "+";
  }
  else {
    output3.innerHTML = Math.floor(tution_fees_per_year * multiplier);
  }
  if(total_number_of_students > 2000 || tution_fees_per_year > 5000) {
    document.getElementById("getStartedButton").style.display = 'none'
    document.getElementById("talkToSalesButton").style.display = 'block'
    output7.innerHTML = '-'
    discount_output.innerHTML = '40%'
    price_per_student_output.innerHTML = '-'
  } else {
    document.getElementById("getStartedButton").style.display = 'block'
    document.getElementById("talkToSalesButton").style.display = 'none'
    output7.innerHTML = currency + ' ' + Math.floor((total_after_discount) * multiplier)
    discount_output.innerHTML = discount_percentage + '%'
    price_per_student_output.innerHTML = currency + ' ' + (Math.round(((total_after_discount/total_number_of_students) * multiplier) * 100) / 100).toFixed(2);
  }
}


// pricing modal code
//Code to go backward
$("body").on("click", ".bk-btn", function () {
  n = $(this).data('step');
  $('.step').hide();
  $('.step.step' + n).show();
});

//Code to go forward
$("body").on("click", ".bk-btn2", function () {
  n = $(this).data('substep');
  $('.substep').hide();
  $('.substep.step-' + n).show();
});


// student slider
var studentSlider = document.getElementById("student-slider");
var studentsCount = document.getElementById("students-count");
if (studentSlider !== null) {
  studentSlider.oninput = function () {
    studentsCount.innerHTML = this.value;
    $(".hidden-students-field").val(studentSlider.value)
  }
}

// school slider
var schoolSlider = document.getElementById("school-slider");
var schoolsCount = document.getElementById("schools-count");
if (schoolSlider !== null) {
  schoolSlider.oninput = function () {
    schoolsCount.innerHTML = this.value;
    $(".hidden-schools-field").val(schoolSlider.value)
  }
}

$(function () {
  //single school plans
  $('.free-plan').click(function () {
    $(".hidden-plan-field").val("free-plan")
    $('.plan-title').text("FREE PLAN")
    studentSlider.value = 100;
    studentsCount.innerHTML = '0 - 100';
    $('.step').show();
    $('.step.step2').hide();
  })

  $('.basic-plan').click(function () {
    $(".hidden-plan-field").val("basic-plan")
    $('.plan-title').text("BASIC PLAN")
    studentSlider.value = 1000;
    studentsCount.innerHTML = '100 - 1000';
    $('.step').show();
    $('.step.step2').hide();
  })

  $('.premium-plan').click(function () {
    $(".hidden-plan-field").val("premium-plan")
    $('.plan-title').text("PREMIUM PLAN")
    studentSlider.value = 10000;
    studentsCount.innerHTML = '1000 - 10000';
    $('.step').hide();
    $('.step.step2').show();
  })

  //multi school plans
  $('.multi-school-basic').click(function () {
    $(".hidden-plan-field").val("multi-school-basic")
    $('.plan-title').text("BASIC PLAN")
    schoolSlider.value = 3;
    schoolsCount.innerHTML = '1 - 3';
    $('.step').show();
    $('.step.step2').hide();
  })

  $('.multi-school-premium').click(function () {
    $(".hidden-plan-field").val("multi-school-premium")
    $('.plan-title').text("PREMIUM PLAN")
    schoolSlider.value = 10;
    schoolsCount.innerHTML = '3 - 10';
    $('.step').show();
    $('.step.step2').hide();
  })

  $('.multi-school-franchise').click(function () {
    $(".hidden-plan-field").val("multi-school-franchise")
    $('.plan-title').text("FRANCHISE PLAN")
    schoolSlider.value = 100;
    schoolsCount.innerHTML = '10 - 100';
    $('.step').hide();
    $('.step.step2').show();
  })

});


